<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-19 11:45:01
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="yx-color-pure-1">
		<el-tooltip placement="top" :content="linkTypeDesc" v-ak-tooltip-auto-show>
			<p class="line-ellipsis-1" style="width: 100%;">{{ linkTypeDesc }}</p>
		</el-tooltip>
		<div class="ml-4 cursor-pointer" @click="open(row)">
			<i class="i-scan-qrcode"></i>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	computed: {
		linkTypeDesc({ row }) {
			let linkName = row?.linkName || '';
			let linkTypeDesc = row?.linkTypeDesc || '';
			return linkName + linkTypeDesc;
		},
	},
	data() {
		return {};
	},
	methods: {
		open({ link, linkType }) {
			const { platformId } = this.row;
			this.row.operations.openPreview({ preview: 'preview_goods', platformId, link, linkType });
		},
	},
};
</script>
<style lang="less" scoped></style>
